module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/fukidashi_black-9f2bb33c2ef0459434d6c8b1398d7454.svg";